module.exports = __webpack_public_path__ + "img/DAY3-3.80fb4731.jpg";